let host = null;

export const registerConfirmHost = (fn) => {
  host = fn;
  return () => {
    if (host === fn) host = null;
  };
};

// Promise-based replacement for window.confirm, rendered by ConfirmDialogHost
export const confirmAction = (options) =>
  new Promise((resolve) => {
    if (!host) {
      resolve(window.confirm(options.message || options.title));
      return;
    }
    host({ ...options, resolve });
  });
